import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getAgent = id => {
  return http.get(
    `${getBaseUrl()}/agent_request/${id}`
  );
};

export const getAgentsList = () => {
  return http.get(
    `${getBaseUrl()}/agents`
  );
};

export const getAgentsListWithPersonId = () => {
  return http.get(
    `${getBaseUrl()}/agents_person_id`
  );
};

export const getAgentsListDetail = (type) => {
  if (type === 'consultation') {
    return http.get(
      `${getBaseUrl()}/consultation_agents_detail`
    );
  } else if (type === 'service') {
    return http.get(
      `${getBaseUrl()}/service_agents_detail`
    );
  }
};

export const getUserAgent = (id) => {
  return http.get(
    `${getBaseUrl()}/user_agent/${id}`
  );
};

export const getAgents = () => {
  return http.get(
    `${getBaseUrl()}/agent_request`
  );
};

export const updateAgentDisplayDetail = data => {
  http.hasFile();
  return http.put(
    `${getBaseUrl()}/agent_display_detail/${data.agent_id}`,
    data
  );
};

export const submitAgent = data => {

  return http.post(
    `${getBaseUrl()}/agent_request`,
    data
  );
};
